import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';

import { CommonModule } from '@angular/common';
import { FullStoryService } from 'fullstory';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'lib-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, ButtonModule],
})
export class PageNotFoundComponent implements OnInit {
  private router = inject(Router);
  private fullStoryService = inject(FullStoryService);

  notFound = false;

  ngOnInit() {
    this.fullStoryService.sendEvent('Home-Dot: 404', {
      url: this.router.url,
    });
    this.notFound = true;
  }

  navigate(): void {
    this.router.navigate(['']);
  }
}
